export const GET_TRUST = "GET_TRUST";
export const TRUST_HOURLY = "TRUST_HOURLY";
export const FIRST_TRUST_HOURLY = "FIRST_TRUST_HOURLY";
export const TRUST_DAILY = "TRUST_DAILY";
export const TRUST_COMMENT_DAILY = "TRUST_COMMENT_DAILY";
export const TRUST_PERIOD = "TRUST_PERIOD";
export const SET_PENDING = "SET_PENDING";
export const SET_ERROR = "SET_ERROR";
export const SET_METHOD = "SET_METHOD";
export const SET_PERIOD_NAME = "SET_PERIOD_NAME";
export const SET_PERIOD = "SET_PERIOD";
export const UPDATE_CHART = "UPDATE_CHART";
export const TO_START_CHART = "TO_START_CHART";
export const SWITCH_ZERO = "SWITCH_ZERO";
export const SET_EMPTY = "SET_EMPTY";
export const SET_COMMON_GLOBAL_PERIOD = "SET_COMMON_GLOBAL_PERIOD";
